export const FORM_REGEX_VALIDATORS = {
  textOnly:
    /^[A-Za-z\u0600-\u065F\u066A-\u06EF\u06FA-\u06FF\u0600-\u065F\u066A-\u06EF\u06FA-\u06FF\s]+$/g,
  textEnglishOnly: /^[A-Za-z\s]+$/g,
  textArabicOnly: /^[\u0621-\u064A\u0660-\u0669 ]+$/g,
  numbersOnly: /^[0-9]*$/g,
  phone: /^(05)(5|0|3|6|4|9|1|8|7)([0-9]{7})$/i,
  loginPhone: /^(?:\+966|00966)(5[0-9]{1})([0-9]{7})$/g,
  phoneNumberRegex : /^[0-9*#+]+$/g,
  password: /^.{4,12}$/g,
  nationalID: /^[0-9]{10}$/g,
  otpNumber: /^[0-9]{3}$/,
  email: /^([\w-.]+@([\w-]+\.)+[\w-]{2,4})$/g,
  validEmail:/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i,
  url:/^(https?|ftp):\/\/([a-zA-Z0-9.-]+)\.([a-zA-Z]{2,})(:[0-9]{1,5})?(\/[^\s]*)?(#[^\s]*)?$/g,
  numbersOnlyGreaterThanOne: /^[1-9][0-9]*$/g,
  numbersOnlyGreaterThanTwo:/^(?:[2-9]|[1-9]\d|[1-9]\d{2})$/g,
  domain: /^[a-zA-Z0-9]+(?:[._-][a-zA-Z0-9]+)*$/g,
};
